export default "__VITE_ASSET__YOJxoXi___"